import ModuleBase, { moduleInit, ViewLayer, implementFunction } from "../../../../framework/core/mvvm/module_base";
import ChatView, { ChatType } from "./chat_view";
import { Notify } from "../../server/notify/proto_notify";
import NotifyServer from "../../server/notify/notify_server";
import CustomerServiceUtil from "../customer_service/customer_service_util";
import EventManager from "../../../../manager/event_manager";
import ModelData, { IUserData } from "../../../public/model_data";
import Utility from "../../../../utility/utility";
import TimeManager from "../../../../manager/time_manager";
import ModelBase from "../../../../framework/core/mvvm/model_base";
import GameServer from "../../server/gameserver/game_server";

import NetMsgDataTableBase from "../../../table/net/net_msg_data_table_base";
import * as ProtoPokerRoom from "../../../table/net/proto/proto_poker_room";
import LoaclStorage from "../../../../manager/local_storage";
import UserDataManager from "../../../../manager/user_manager";
import HornView from "./horn_view";
import AppData from "../../../public/const/app_data";

const {ccclass, property} = cc._decorator;


@ccclass
@moduleInit("Horn")
export default class Horn extends ModuleBase<HornView, null> {

    readyMsg:string=""
    
    LastSendChatTime: number;
    allFriendMsgList:Notify.ChatMessage[]=[]  //所有私聊信息
    
    sendLastFriendMsg:Notify.IChatMessage=null
    _model: ModelBase = new ModelBase()
    isFristLoad=true;
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/hall/module/chat/horn';
        this.viewType = HornView;
        //this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = false;
        
        //this.needViewBaseCloseBtn = true
        
    }
    onInit()
    {    
        this.view.closeBtn.node.on('click', this.onClick_btnClose, this);
        this.view.sendBtn.node.on('click', this.onClick_send, this);
    }
   
    private onClick_btnClose() {
        this.hide()
        
    }
   
    onClick_send()
    {
        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.LastSendChatTime > 0 && this.LastSendChatTime + 2.6 > AppRunningTime) {
            //ModuleManager.instance.toast("对话过于频繁,歇息一会再发吧")
            return
        }
        this.LastSendChatTime = AppRunningTime
        if(this.view.inputTxt.string=="")
        {
            return
        }
        this.readyMsg=this.view.inputTxt.string
        this.sendToWorld()
    }
    
    sendToWorld() {
      
        let gender = ModelData.instance.roleData.gender;
        this.view.inputTxt.string=""
        let requestData: IHttpRequestData = {
            baseUrl: 'chat/horn?',
            params: {
                gameUserId:ModelData.instance.roleData.id,
                groupChatName:"world",
                content: JSON.stringify({ content : this.readyMsg ,gender : gender, type : "horn"}) ,  
            }
        }
        this.apiHttpGet(requestData, (retData) => {
            UserDataManager.getDataFromServer(ModelData.instance.roleData.id, ()=>{});
           cc.log(retData)
        }, (error) => {
            if (error.code == "X00150" || error.code == "B00036") {
               cc.log("bbbbbbbbbbbbbbbbbbbbb")
            }
        })

        this.hide();
    }
    onShow(arg0)
    {
        
    }
    
   
    
   
   
    
}
